















import { Vue, Component, Prop } from "vue-property-decorator";

@Component({ components: {} })
export default class CustomTableItem extends Vue {
  @Prop({ default: false }) itemRemoving!: boolean;
  get screenWidth() {
    return this.$store.getters.SCREEN_WIDTH
      ? this.$store.getters.SCREEN_WIDTH
      : window.innerWidth;
  }
}
